module.exports = __webpack_public_path__ + "img/arrow-left.98e87add.svg";